/**
 * Compares the current app version against the latest version available to determine the relationship.
 *
 * @param currentVersion The current version of the app.
 * @param latestVersion The latest version available from the API.
 * @returns Returns "greater" if the current version is greater than the latest version, "less" if the current version is less than the latest version, and "equal" if they are the same.
 */
export const compareAppVersions = (currentVersion: string, latestVersion: string): 'greater' | 'less' | 'equal' => {
    const versionPartsCurrent = currentVersion.split('.').map(Number);
    const versionPartsLatest = latestVersion.split('.').map(Number);

    for (let i = 0; i < Math.max(versionPartsCurrent.length, versionPartsLatest.length); i++) {
        const partCurrent = versionPartsCurrent[i] || 0;
        const partLatest = versionPartsLatest[i] || 0;

        if (partCurrent > partLatest) {
            return 'greater';
        }
        if (partCurrent < partLatest) {
            return 'less';
        }
    }

    return 'equal'; // The versions are equal if all parts are equal
};
